export default "__VITE_ASSET__CJETqmNZ__"